import React, { useEffect } from 'react';
import { Sparkles } from 'lucide-react';

export default function AuthLayout({ children, title, subtitle }) {
    useEffect(() => {
        // Get saved theme preference or default to 'system'
        const savedTheme = localStorage.getItem('amica-theme') || 'system';

        const applyTheme = (theme) => {
            if (theme === 'system') {
                const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
                document.documentElement.classList.toggle('dark', prefersDark);
            } else {
                document.documentElement.classList.toggle('dark', theme === 'dark');
            }
        };

        // Apply the theme
        applyTheme(savedTheme);

        // Listen for system theme changes if using system theme
        if (savedTheme === 'system') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            const handleChange = (e) => {
                document.documentElement.classList.toggle('dark', e.matches);
            };

            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-purple-50 to-slate-100 dark:from-slate-900 dark:via-indigo-950 dark:to-slate-900 p-4">
            <div className="max-w-md w-full p-8 backdrop-blur-md bg-white/80 dark:bg-slate-900/80 border border-slate-200/50 dark:border-slate-700/50 shadow-2xl rounded-xl">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white mb-4 shadow-lg animate-pulse-slow">
                        <Sparkles className="w-8 h-8" />
                    </div>
                    <h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-2">
                        Diary AI
                    </h1>
                    {title && (
                        <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-100 mt-4">
                            {title}
                        </h2>
                    )}
                    {subtitle && (
                        <p className="text-slate-600 dark:text-slate-300 text-sm mt-2">
                            {subtitle}
                        </p>
                    )}
                </div>
                {children}
            </div>
        </div>
    );
}
